/**
 * FX-1…FX-8 · the *Napi árfolyamok* strings. Spread into `HU` and `EN` in `./catalogue.ts`; a key in
 * one and not the other is a type error there.
 *
 * ⚠️ Every `{date}` and `{code}` below sits where no suffix follows it — `{code}-ról` is wrong for
 * half the codes there are, so the sentences put the placeholder after a colon instead.
 */
export const HU = {
  /* ── the two tabs ── */
  'fx.tab.daily': 'Napi árfolyamok',

  /* ── tab 1 · Pénznemek ── */
  'fx.column.currency': 'Pénznem',
  'fx.column.name': 'Megnevezés',
  'fx.column.today': 'Mai árfolyam',

  /* ── tab 2 · Napi árfolyamok ── */
  'fx.column.date': 'Dátum',
  'fx.column.pair': '{code} / {base}',
  'fx.column.source': 'Forrás',
  'fx.source.ecb': 'ECB',
  'fx.source.manual': 'Kézi',
  'fx.subline.synced': 'ECB · utolsó lekérdezés: {at} · a napi érték kézzel felülírható',
  'fx.subline.never': 'ECB · még nem volt lekérdezés · a napi érték kézzel felülírható',
  'fx.sync': 'Lekérdezés most',
  'fx.syncing': 'Lekérdezés…',
  'fx.table': 'Napi árfolyamok',
  'fx.empty': 'Még nincs napi árfolyam',
  'fx.emptyBody':
    'A Lekérdezés most gomb letölti az ECB árfolyamait. Utána minden banki nap itt lesz, és bármelyik értéke átírható.',

  /* ── one cell ── */
  'fx.cell': 'Árfolyam: {code}, {date}',
  'fx.cell.none': 'Erre a napra nincs árfolyam',
  'fx.cell.manual': 'Kézzel átírt érték',
  'fx.cell.bank': 'A bank értéke: {value}',
  'fx.cell.restore': 'Banki érték visszaállítása: {code}, {date}',
  'fx.cell.save': 'Mentés: {code}, {date}',
  'fx.cell.cancel': 'Elvetés: {code}, {date}',
  'fx.cell.invalid': 'Pozitív számot írj, például 395,20.',
  'fx.cell.pending': 'Nincs mentve. Enter ment, Esc elvet.',

  /* ── what a write answers ── */
  'fx.toast.saved': 'Árfolyam átírva: {code}, {date}',
  'fx.toast.restored': 'Banki érték visszaállítva: {code}, {date}',
  'fx.toast.undo': 'Visszavonás',
  'fx.toast.undoFailed': 'A visszavonás nem sikerült',
  'fx.toast.synced': 'Árfolyamok frissítve',
  'fx.toast.syncFailed': 'Nem sikerült lekérdezni az árfolyamokat',
  'fx.toast.bankDown': 'Az ECB most nem válaszolt. Próbáld újra később.',
  'fx.error.notBankingDay':
    'Erre a napra nincs banki árfolyam, ezért nem írható át: {code}, {date}.',
  'fx.error.stale':
    'Valaki közben módosította ezt az értéket: {code}, {date}. Frissítettük a táblázatot, próbáld újra.',
  'fx.error.load': 'A napi árfolyamok nem töltődtek be, ezért a táblázat most üres. Próbáld újra.',
  'fx.retry': 'Újra',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  'fx.tab.daily': 'Daily rates',

  'fx.column.currency': 'Currency',
  'fx.column.name': 'Name',
  'fx.column.today': "Today's rate",

  'fx.column.date': 'Date',
  'fx.column.pair': '{code} / {base}',
  'fx.column.source': 'Source',
  'fx.source.ecb': 'ECB',
  'fx.source.manual': 'Manual',
  'fx.subline.synced': 'ECB · last fetched {at} · any day can be overwritten by hand',
  'fx.subline.never': 'ECB · never fetched yet · any day can be overwritten by hand',
  'fx.sync': 'Fetch now',
  'fx.syncing': 'Fetching…',
  'fx.table': 'Daily rates',
  'fx.empty': 'No daily rates yet',
  'fx.emptyBody':
    'Fetch now downloads the ECB rates. Every banking day then appears here, and any of its values can be overwritten.',

  'fx.cell': '{code} rate on {date}',
  'fx.cell.none': 'No rate for this day',
  'fx.cell.manual': 'Edited by hand',
  'fx.cell.bank': "The bank's value: {value}",
  'fx.cell.restore': "Restore the bank's value: {code}, {date}",
  'fx.cell.save': 'Save: {code}, {date}',
  'fx.cell.cancel': 'Discard: {code}, {date}',
  'fx.cell.invalid': 'Enter a positive number, for example 395.20.',
  'fx.cell.pending': 'Not saved. Enter saves, Esc discards.',

  'fx.toast.saved': 'Rate changed: {code}, {date}',
  'fx.toast.restored': "Bank's value restored: {code}, {date}",
  'fx.toast.undo': 'Undo',
  'fx.toast.undoFailed': 'The undo did not go through',
  'fx.toast.synced': 'Rates updated',
  'fx.toast.syncFailed': 'The rates could not be fetched',
  'fx.toast.bankDown': 'The ECB did not answer just now. Try again later.',
  'fx.error.notBankingDay':
    'That day has no bank rate, so it cannot be overwritten: {code}, {date}.',
  'fx.error.stale':
    'Somebody changed this value meanwhile: {code}, {date}. The table has been refreshed; try again.',
  'fx.error.load': 'The daily rates did not load, so the table is empty for now. Try again.',
  'fx.retry': 'Retry',
};
